var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row"},[_c('sort-filter',{staticClass:"mr-5",attrs:{"categories":_vm.sortList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }